/**
 * Prefer CRM association instance label over the snapshotted participant
 * displayName (matches thread breadcrumb priority).
 */
export function resolveContactTileDisplayName(
  displayName: string,
  associations?: Array<{ label?: string | null }> | null,
): string {
  const label = associations?.[0]?.label?.trim();
  return label || displayName;
}
